import { queryOptions, useQuery } from "@tanstack/react-query";
import { type StaticDecode, Type } from "typebox";
import * as TypeCompiler from "typebox/compile";
import { ReadonlyObject } from "@/shared/schema/schema.ts";
import { httpChecked } from "@/shared/util/fetch.tsx";

const settingsSchema = ReadonlyObject({
  proposalAssistant: Type.Boolean(),
});
export type AiSettings = StaticDecode<typeof settingsSchema>;

const SettingsChecker = TypeCompiler.Compile(settingsSchema);

const queries = {
  fetch: queryOptions({
    queryKey: ["ai-settings", "data"] as const,
    queryFn: ({ signal }) =>
      httpChecked.get("/ai-settings", SettingsChecker, { signal }),
  }),
};

function useAiSettings() {
  const { data } = useQuery({ ...queries.fetch, staleTime: 60_000 });

  return data;
}

export function useIsProposalAssistantEnabled() {
  const settings = useAiSettings();

  if (!settings) {
    return false;
  }

  return settings.proposalAssistant;
}
